import React from 'react';
import { useLottie } from 'lottie-react';
import groovyWalkAnimation from '../../hudini_loading.json';
import './Loader.scss';

function Loader(props) {
  const { View } = useLottie({
    animationData: groovyWalkAnimation,
    loop: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  return (
    <div className='loader-container d-flex justify-content-center align-items-center h-100'>
      <div className='spinner-content'>{View}</div>
    </div>
  );
}

export default Loader;
